// API service for conversation threads following the users pattern
import apiClient from './apiClient';

class ThreadsAPI {

  // POST /conversation/threads/
  async createThread(threadData) {
    return apiClient.makeAuthenticatedRequest('/conversation/threads/', {
      method: 'POST',
      body: JSON.stringify(threadData),
    });
  }

  // GET /conversation/threads/?owner_id=...&limit=...&offset=...
  async getThreadsByOwner(ownerId, limit = 100, offset = 0) {
    const params = new URLSearchParams({
      owner_id: String(ownerId),
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/threads/{thread_id}
  async getThreadById(threadId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/${encodeURIComponent(threadId)}`, {
      method: 'GET',
    });
  }

  // GET /conversation/threads/{thread_id} (public access)
  async getThreadByIdPublic(threadId) {
    return apiClient.makePublicRequest(`/conversation/threads/${encodeURIComponent(threadId)}`, {
      method: 'GET',
    });
  }

  // PUT /conversation/threads/{thread_id}
  async updateThread(threadId, updateData) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/${encodeURIComponent(threadId)}`, {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  }

  // DELETE /conversation/threads/{thread_id}
  async deleteThread(threadId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/${encodeURIComponent(threadId)}`, {
      method: 'DELETE',
    });
  }

  // GET /conversation/threads/{thread_id}/with-sessions
  async getThreadWithSessions(threadId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/${encodeURIComponent(threadId)}/with-sessions`, {
      method: 'GET',
    });
  }

  // GET /conversation/threads/owner/{owner_id}/recent?days=&limit=
  async getRecentThreads(ownerId, days = 7, limit = 10) {
    const params = new URLSearchParams({
      days: String(days),
      limit: String(limit),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/owner/${encodeURIComponent(ownerId)}/recent?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/threads/owner/{owner_id}/search?label=
  async searchThreadsByLabel(ownerId, label) {
    const params = new URLSearchParams({
      label: String(label),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/owner/${encodeURIComponent(ownerId)}/search?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/threads/owner/{owner_id}/count
  async getThreadCount(ownerId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/owner/${encodeURIComponent(ownerId)}/count`, {
      method: 'GET',
    });
  }

  // DELETE /conversation/threads/owner/{owner_id}/all
  async deleteAllOwnerThreads(ownerId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/threads/owner/${encodeURIComponent(ownerId)}/all`, {
      method: 'DELETE',
    });
  }

  // GET /conversation/threads/?owner_id=...&limit=...&offset=... (public access)
  async getPublicThreadsByOwner(ownerId, limit = 100, offset = 0) {
    const params = new URLSearchParams({
      owner_id: String(ownerId),
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return apiClient.makePublicRequest(`/conversation/threads/?${params}`, {
      method: 'GET',
    });
  }
}

export default new ThreadsAPI();


